import Layout from '@/layouts/Layout.vue'

/**
 * 静态路由（无需权限）
 */
export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', hidden: true }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: { title: '404', hidden: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: '首页', icon: 'el-icon-s-home' },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home', code: 'dashboard' }
      }
    ]
  }
]

/**
 * 动态路由（需权限控制）
 */
export const asyncRoutes = [
  {
    path: '/notification',
    component: Layout,
    redirect: '/notification/list',
    meta: { title: '通知管理', icon: 'el-icon-bell', code: 'notification' },
    children: [
      {
        path: 'list',
        name: 'NotificationList',
        component: () => import('@/views/notification/index.vue'),
        meta: { title: '通知列表', icon: 'el-icon-bell', code: 'notification_list' }
      }
    ]
  },
  {
    path: '/report',
    component: Layout,
    redirect: '/report/business',
    meta: { title: '报表统计', icon: 'el-icon-s-data', code: 'report' },
    children: [
      {
        path: 'business',
        name: 'ReportBusiness',
        component: () => import('@/views/report/business.vue'),
        meta: { title: '业务统计', icon: 'el-icon-data-line', code: 'report_business' }
      },
      {
        path: 'fund',
        name: 'ReportFund',
        component: () => import('@/views/report/fund.vue'),
        meta: { title: '资金报表', icon: 'el-icon-s-finance', code: 'report_fund' }
      },
      {
        path: 'region',
        name: 'ReportRegion',
        component: () => import('@/views/report/region.vue'),
        meta: { title: '区域汇总', icon: 'el-icon-map-location', code: 'report_region' }
      },
      {
        path: 'org-performance',
        name: 'ReportOrgPerformance',
        component: () => import('@/views/report/orgPerformance.vue'),
        meta: { title: '机构业绩', icon: 'el-icon-s-flag', code: 'report_org_performance' }
      }
    ]
  },
  {
    path: '/voucher',
    component: Layout,
    redirect: '/voucher/chains',
    meta: { title: '凭证管理', icon: 'el-icon-coin', code: 'voucher' },
    children: [
      {
        path: 'chains',
        name: 'VoucherChainList',
        component: () => import('@/views/voucher/index.vue'),
        meta: { title: '凭证与链条', icon: 'el-icon-coin', code: 'voucher_chain' }
      }
    ]
  },
  {
    path: '/audit',
    component: Layout,
    redirect: '/audit/pending',
    meta: { title: '审核管理', icon: 'el-icon-s-check', code: 'audit' },
    children: [
      {
        path: 'pending',
        name: 'AuditPendingList',
        component: () => import('@/views/audit/pending.vue'),
        meta: { title: '待审核', icon: 'el-icon-time', code: 'audit_pending' }
      },
      {
        path: 'records',
        name: 'AuditRecordList',
        component: () => import('@/views/audit/records.vue'),
        meta: { title: '审核记录', icon: 'el-icon-document', code: 'audit_records' }
      }
    ]
  },
  {
    path: '/risk',
    component: Layout,
    redirect: '/risk/records',
    meta: { title: '风控管理', icon: 'el-icon-warning', code: 'risk' },
    children: [
      {
        path: 'records',
        name: 'RiskRecordList',
        component: () => import('@/views/risk/index.vue'),
        meta: { title: '风控记录', icon: 'el-icon-warning', code: 'risk_records' }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/list',
    meta: { title: '订单管理', icon: 'el-icon-s-order', code: 'order' },
    children: [
      {
        path: 'list',
        name: 'OrderList',
        component: () => import('@/views/order/index.vue'),
        meta: { title: '订单管理', icon: 'el-icon-s-order', code: 'order_list' }
      },
      {
        path: 'create',
        name: 'CreateOrder',
        component: () => import('@/views/order/create.vue'),
        meta: { title: '创建订单', icon: 'el-icon-circle-plus-outline', code: 'order_create' }
      }
    ]
  },
  {
    path: '/withdraw',
    component: Layout,
    redirect: '/withdraw/list',
    meta: { title: '出金管理', icon: 'el-icon-bank-card', code: 'withdraw' },
    children: [
      {
        path: 'list',
        name: 'WithdrawList',
        component: () => import('@/views/withdraw/index.vue'),
        meta: { title: '出金申请', icon: 'el-icon-tickets', code: 'withdraw_list' }
      },
      {
        path: 'forced',
        name: 'ForcedWithdrawList',
        component: () => import('@/views/withdraw/forced.vue'),
        meta: { title: '强制出金', icon: 'el-icon-warning-outline', code: 'withdraw_forced' }
      }
    ]
  },
  {
    path: '/exchange',
    component: Layout,
    redirect: '/exchange/list',
    meta: { title: '兑换管理', icon: 'el-icon-present', code: 'exchange' },
    children: [
      {
        path: 'list',
        name: 'ExchangeList',
        component: () => import('@/views/exchange/index.vue'),
        meta: { title: '兑换记录', icon: 'el-icon-tickets', code: 'exchange_list' }
      }
    ]
  },
  {
    path: '/payment',
    component: Layout,
    redirect: '/payment/list',
    meta: { title: '支付管理', icon: 'el-icon-wallet', code: 'payment' },
    children: [
      {
        path: 'list',
        name: 'PaymentList',
        component: () => import('@/views/payment/index.vue'),
        meta: { title: '支付单管理', icon: 'el-icon-bank-card', code: 'payment_list' }
      },
      {
        path: 'fund-flows',
        name: 'FundFlowList',
        component: () => import('@/views/payment/fundFlows.vue'),
        meta: { title: '资金流水', icon: 'el-icon-money', code: 'payment_fund_flows' }
      }
    ]
  },
  {
    path: '/contract',
    component: Layout,
    redirect: '/contract/templates',
    meta: { title: '合同管理', icon: 'el-icon-document', code: 'contract' },
    children: [
      {
        path: 'templates',
        name: 'ContractTemplates',
        component: () => import('@/views/contract/templates.vue'),
        meta: { title: '合同模板', icon: 'el-icon-document-copy', code: 'contract_templates' }
      },
      {
        path: 'documents',
        name: 'ContractDocuments',
        component: () => import('@/views/contract/documents.vue'),
        meta: { title: '合同文档', icon: 'el-icon-tickets', code: 'contract_documents' }
      },
      {
        path: 'parties',
        name: 'ContractParties',
        component: () => import('@/views/contract/parties.vue'),
        meta: { title: '主体配置', icon: 'el-icon-s-custom', code: 'contract_parties' }
      }
    ]
  },
  {
    path: '/org',
    component: Layout,
    redirect: '/org/list',
    meta: { title: '组织管理', icon: 'el-icon-office-building', code: 'org' },
    children: [
      {
        path: 'list',
        name: 'OrgList',
        component: () => import('@/views/org/index.vue'),
        meta: { title: '组织管理', icon: 'el-icon-office-building', code: 'org_list' }
      }
    ]
  },
  {
    path: '/split-template',
    component: Layout,
    redirect: '/split-template/list',
    meta: { title: '分账模板', icon: 'el-icon-s-grid', code: 'split_template' },
    children: [
      {
        path: 'list',
        name: 'SplitTemplateList',
        component: () => import('@/views/splitTemplate/index.vue'),
        meta: { title: '模板管理', icon: 'el-icon-s-grid', code: 'split_template_list' }
      }
    ]
  },
  {
    path: '/split-detail',
    component: Layout,
    redirect: '/split-detail/list',
    meta: { title: '分账明细', icon: 'el-icon-document', code: 'split_detail' },
    children: [
      {
        path: 'list',
        name: 'SplitDetailList',
        component: () => import('@/views/splitDetail/index.vue'),
        meta: { title: '明细管理', icon: 'el-icon-document', code: 'split_detail_list' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    meta: { title: '用户管理', icon: 'el-icon-user', code: 'user' },
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: () => import('@/views/user/index.vue'),
        meta: { title: 'C端用户', icon: 'el-icon-user', code: 'user_list' }
      }
    ]
  },
  {
    path: '/content',
    component: Layout,
    redirect: '/content/banners',
    meta: { title: '内容管理', icon: 'el-icon-picture-outline', code: 'content' },
    children: [
      {
        path: 'banners',
        name: 'BannerList',
        component: () => import('@/views/content/banners.vue'),
        meta: { title: '轮播图管理', icon: 'el-icon-picture', code: 'banner_list' }
      },
      {
        path: 'notices',
        name: 'NoticeList',
        component: () => import('@/views/content/notices.vue'),
        meta: { title: '公告管理', icon: 'el-icon-bell', code: 'notice_list' }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/admins',
    meta: { title: '系统管理', icon: 'el-icon-setting', code: 'system' },
    children: [
      {
        path: 'admins',
        name: 'AdminList',
        component: () => import('@/views/system/admins/index.vue'),
        meta: { title: '管理员管理', icon: 'el-icon-user-solid', code: 'admin_manage' }
      },
      {
        path: 'roles',
        name: 'RoleList',
        component: () => import('@/views/system/roles/index.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-check', code: 'role_manage' }
      },
      {
        path: 'permissions',
        name: 'PermissionList',
        component: () => import('@/views/system/permissions/index.vue'),
        meta: { title: '权限管理', icon: 'el-icon-lock', code: 'permission_manage' }
      },
      {
        path: 'configs',
        name: 'SystemConfigs',
        component: () => import('@/views/system/configs.vue'),
        meta: { title: '系统配置', icon: 'el-icon-s-tools', code: 'config_manage' }
      },
      {
        path: 'operation-logs',
        name: 'OperationLogList',
        component: () => import('@/views/system/operationLogs/index.vue'),
        meta: { title: '操作日志', icon: 'el-icon-document', code: 'operation_log' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    meta: { hidden: true }
  }
]
